import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, transition, animate, style } from '@angular/animations';
import { SchematicAndObservationPointDetails, 
  ComponentObservationPointDetails, SchematicDetails, ImplementForEquipmentDetails } from '../../equipment-details/equipment-details.model';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../../../app.service';
import { MatDialog } from '@angular/material/dialog';import { AddFecrRecommendationComponent } from '../add-fecr-recommendation/add-fecr-recommendation.component';
import { ImplementRebuildService } from '../fecr-implement-rebuild-details/implement-rebuild.service';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-fecr-observation-details',
  templateUrl: './fecr-observation-details.component.html',
  styleUrls: ['./fecr-observation-details.component.scss'],
  animations: [
    trigger(
        'fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 0 }),
                animate('0ms', style({ opacity: 0 }))
            ])
        ]
    )]
})
export class FecrObservationDetailsComponent implements OnInit {

  @Input() SchematicAndObservationPoints: SchematicAndObservationPointDetails = new SchematicAndObservationPointDetails();
  @Input() selectedIndex:number;
    @Input() cusID: number;

@Input() implementId:number;
@Output() updateObs: EventEmitter<boolean> = new EventEmitter();

//appUris:AppUris;
ImplementForEquipmentDetails: ImplementForEquipmentDetails[] = [];
    oldGETUri: string;
    ObservationPointDetails: ComponentObservationPointDetails[];
    schematicDetails: SchematicDetails;
    constructor(private _sanitizer: DomSanitizer,public dialog: MatDialog, private _moduleService : ImplementRebuildService,
        private _appService: AppService,
        private readonly _pref: PreferencesService,
        private _router: Router, ) { }

    ngOnInit() {
        this.ObservationPointDetails = this.SchematicAndObservationPoints.ObservationPoints;
        this.schematicDetails = this.SchematicAndObservationPoints.Schematic;

        console.log("info____",  this.SchematicAndObservationPoints.ObservationPoints )
        console.log("selectedIndex", this.selectedIndex)

        //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
        //this.appUris.UCUri
    }

    loading:boolean=false;
    loadObservationDetails() {

        this.loading = true;
        this._moduleService.GetSchematicsForImplement(this.implementId).subscribe(details => {
          this.ImplementForEquipmentDetails = details;

          console.log("info____1111",   this.ImplementForEquipmentDetails[0] )
          this.ObservationPointDetails = this.ImplementForEquipmentDetails[0].SchematicAndObservationPoints[0].ObservationPoints;
          this.loading = false
        });
    
      }
    sanitize(image: string) {

        //return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
        return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
    }

    getEvalClass(wornPct: number) {
        if ((wornPct >= 0)&&(wornPct <= 30)) {
            return " WornPctCell evalColorA";
        }
        else if ((wornPct > 30) && (wornPct <= 60)) {
            return " WornPctCell evalColorB";
        }
        else if ((wornPct > 60) && (wornPct <= 80)) {
            return " WornPctCell evalColorC";
        }
        else if ((wornPct > 80)|| (wornPct < 0) ){
            return "WornPctCell evalColorX";
        }

        return " WornPctCell noEval";
    }

    getEvalClass2(evalCode: string) {
        if (evalCode == "A") {
            return " WornPctCell evalColorA";
        }
        else if (evalCode == "B") {
            return " WornPctCell evalColorB";
        }
        else if (evalCode == "C") {
            return " WornPctCell evalColorC";
        }
        else if (evalCode == "X") {
            return "WornPctCell evalColorX";
        }

        return " WornPctCell noEval";
    }
    
    gotoObservationListPage() {
        this._appService.getApplicationConfigValue("oldGETUri").subscribe(result => {
            this.oldGETUri = result;
            if (this.cusID <= 0) {
                window.open(this.oldGETUri + 'GET/SelectObservationListCustomer.aspx', '');
            }
            else {
                window.open(this.oldGETUri + 'GET/ManageObservationLists.aspx?cu=' + this.cusID, '');
            }
        });
    }

    gotoModifyImplementPage() {
        window.open('setup/existing-implement');

    }

    //open Recommendation
    OpenRecommendation(ObsId:number){
        let openRemoveImplementModalRef = this.dialog.open(AddFecrRecommendationComponent, {
            disableClose:true,
            // width: '1230px',
            data: {
                    obsId:ObsId,
                    ImplementId:this.implementId
            }
          });
          openRemoveImplementModalRef.afterClosed().subscribe(res => {
              console.log("res____", res)
              if(res==true){
                this.updateObs.emit(true);
              }
          });
    }
    OpenObsHistory(ObsId:number) {
      //  window.open('/fecr/obspointhistory/'+ this.implementId +'/' + ObsId ,'_blank'); 

      this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
        if(res=="True"){
          this._router.navigate(['/fecr/obspointhistory', this.implementId, ObsId]);
        }else{             
            window.open('/fecr/obspointhistory/'+ this.implementId +'/' + ObsId ,'_blank');
         
        }
    });

    }

    getApprovalColour(approval:boolean, response:boolean){
        if(approval==true && response==false){
           return 'bushClass-X'
        }else if(approval==true && response == true){
            return 'bushClass-A'
        }else{
            return 'bushClass-U'
        }
    }
      
   
}

